import { Chip, DropDown, DropDownItem } from '@features/common';
import { ComboData, NumberKeyData } from '@interfaces/firebase.interfaces';
import { Grid, Typography } from '@mui/material';

interface Props {
	combos?: ComboData;
	data: number[];
	id: string;
	noResults: string;
	service_levels?: NumberKeyData;
}

const ProcessDropdown: React.FC<Props> = ({ combos, data, id, noResults, service_levels }) =>
	data.length === 0 ? (
		<Typography fontFamily="Montserrat" fontSize={14} style={{ marginTop: 4 }}>
			{noResults}
		</Typography>
	) : (
		<Grid container style={{ gap: 8, marginTop: 8 }}>
			{data.slice(0, 4).map((d, i) => (
				<Grid item key={`${id}-chip-${d}-${i}`}>
					<Chip
						id={`${id}-chip-${d}`}
						label={d}
						style={{ minWidth: 41, textAlign: 'center' }}
						tooltip={
							service_levels
								? service_levels[d] ?? 'Servicio no registrado'
								: combos
								? combos[d]?.nombre_combo ?? 'Combo no registrado'
								: ''
						}
					/>
				</Grid>
			))}
			{data.length > 4 && (
				<div style={{ marginTop: '6px', marginLeft: '6px' }}>
					<DropDown
						id={`${id}-dropdown`}
						title={
							<Typography
								color="#1063AC"
								fontFamily="Montserrat"
								fontSize={10}
								fontWeight={500}
								style={{ textDecoration: 'underline' }}
							>
								Ver más
							</Typography>
						}
					>
						{data.slice(4).map((d, i) => (
							<DropDownItem
								code={d.toString()}
								id={`${id}-dropdown-${d}`}
								key={`${id}-dropdown-${d}-${i}`}
								title={
									service_levels
										? service_levels[d] ?? 'Servicio no registrado'
										: combos
										? combos[d]?.nombre_combo ?? 'Combo no registrado'
										: ''
								}
							/>
						))}
					</DropDown>
				</div>
			)}
		</Grid>
	);

export default ProcessDropdown;
